/**
 * The caller's linked messaging channels (block 24). `refetchInterval` lets the
 * settings page poll while a link code is on screen, so the link shows up.
 */
import { useQuery } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useLinkedChannels(options = {}) {
    return useQuery({
        queryKey: queryKeys.channels.all(),
        queryFn: () => getNookClient().listLinkedChannels(),
        refetchInterval: options.refetchInterval ?? false,
    });
}
//# sourceMappingURL=use-linked-channels.js.map